const glossaryTerms = [
  {
    term: "Mercado Livre de Energia",
    slug: "mercado-livre-de-energia",
    category: "Mercado e Contratos",
    description:
      "Saiba como funciona o Mercado Livre de Energia e quando ele pode reduzir o custo elétrico da sua empresa.",
    definition:
      "O Mercado Livre de Energia é o ambiente em que empresas negociam energia com condições comerciais personalizadas, em vez de ficar apenas na tarifa padrão da distribuidora. Na prática, você pode contratar energia com previsibilidade maior de preço e adequação ao perfil de consumo da sua operação.",
    impact:
      "Para empresas com consumo relevante, entender esse modelo ajuda a reduzir exposição a aumentos tarifários e apoiar decisões de contratação com mais controle financeiro.",
    whenToReview: [
      "Quando a conta de energia cresce acima da inflação da empresa.",
      "Quando existe meta de redução de custos fixos para o próximo ciclo orçamentário.",
      "Quando a operação tem consumo estável e previsível ao longo do ano.",
    ],
  },
  {
    term: "ACL (Ambiente de Contratação Livre)",
    slug: "acl-ambiente-de-contratacao-livre",
    category: "Mercado e Contratos",
    description:
      "Entenda o ACL e como empresas contratam energia com mais flexibilidade comercial.",
    definition:
      "ACL é o ambiente em que consumidores elegíveis negociam energia diretamente com comercializadores e geradores. Diferente do modelo regulado, o ACL permite desenhar contratos conforme prazo, volume, sazonalidade e estratégia de custo da empresa.",
    impact:
      "Conhecer o ACL é importante para avaliar oportunidades de economia recorrente e reduzir incerteza de preço na conta de luz.",
    whenToReview: [
      "Quando a empresa começa a estudar migração de modelo de compra de energia.",
      "Quando existe necessidade de previsibilidade para contratos de médio e longo prazo.",
      "Quando a diretoria busca alternativas para ganho de competitividade.",
    ],
  },
  {
    term: "ACR (Ambiente de Contratação Regulada)",
    slug: "acr-ambiente-de-contratacao-regulada",
    category: "Mercado e Contratos",
    description:
      "Veja o que é ACR e como esse ambiente influencia o custo energético da empresa.",
    definition:
      "ACR é o ambiente regulado em que a energia é fornecida pela distribuidora local com regras tarifárias definidas pela regulação. Nesse formato, o consumidor segue estruturas e reajustes determinados para a área de concessão.",
    impact:
      "Entender o ACR permite comparar alternativas de contratação e identificar quando manter ou complementar o modelo atual faz mais sentido para a operação.",
    whenToReview: [
      "Quando há reajustes expressivos da distribuidora.",
      "Quando o financeiro precisa comparar cenário atual versus alternativas.",
      "Quando o consumo muda por expansão de unidades ou turnos.",
    ],
  },
  {
    term: "Geração Distribuída (GD)",
    slug: "geracao-distribuida-gd",
    category: "Regulação e Operação",
    description:
      "Entenda a Geração Distribuída e como ela viabiliza economia para CNPJ sem obra no telhado.",
    definition:
      "Geração Distribuída é o modelo em que a energia é produzida em unidades próximas ao consumo e compensada na fatura, conforme regras vigentes. Na prática empresarial, ela pode ser usada por meio de assinaturas e créditos de energia, sem necessidade de instalar painéis na própria unidade.",
    impact:
      "A GD amplia acesso à economia energética com menor fricção operacional e pode acelerar decisões de redução de custos.",
    whenToReview: [
      "Quando a empresa quer reduzir conta sem CAPEX inicial.",
      "Quando não há espaço físico ou interesse em obra local.",
      "Quando existem metas ESG e de eficiência operacional.",
    ],
  },
  {
    term: "Geração Compartilhada",
    slug: "geracao-compartilhada",
    category: "Regulação e Operação",
    description:
      "Saiba o que é geração compartilhada e como créditos de energia chegam à sua fatura.",
    definition:
      "Geração compartilhada é uma modalidade de GD em que vários consumidores participam de uma mesma estrutura de geração e recebem compensação proporcional. É a base de muitos modelos de assinatura energética para empresas e pessoas jurídicas.",
    impact:
      "Esse formato permite entrada rápida, sem obra, com potencial de economia mensal e contratação simplificada.",
    whenToReview: [
      "Quando o objetivo é reduzir custo fixo sem investir em ativos próprios.",
      "Quando há necessidade de onboarding rápido de múltiplas unidades.",
      "Quando a empresa quer validar economia antes de expandir adesão.",
    ],
  },
  {
    term: "Comunidade de Energia",
    slug: "comunidade-de-energia",
    category: "Regulação e Operação",
    description:
      "Veja como comunidades de energia funcionam e onde elas geram eficiência para empresas.",
    definition:
      "Comunidade de energia é o arranjo em que consumidores compartilham benefícios de geração em uma rede estruturada. No contexto corporativo, isso pode significar acesso a energia com melhor previsibilidade de custo e operação coordenada por um agente especializado.",
    impact:
      "A comunidade reduz barreiras de entrada e facilita escala de adesão para empresas com várias unidades consumidoras.",
    whenToReview: [
      "Quando a empresa tem diferentes filiais na mesma área de atendimento.",
      "Quando há busca por modelo mais colaborativo de contratação energética.",
      "Quando se deseja governança centralizada da economia obtida.",
    ],
  },
  {
    term: "Consórcio de Energia",
    slug: "consorcio-de-energia",
    category: "Mercado e Contratos",
    description:
      "Entenda o conceito de consórcio de energia aplicado à redução da conta de luz empresarial.",
    definition:
      "Consórcio de energia, no contexto operacional, é uma estrutura jurídica e comercial que organiza consumidores para acesso a benefícios de geração e compensação. Ele define responsabilidades contratuais, critérios de adesão e regras de alocação de créditos.",
    impact:
      "Conhecer o consórcio ajuda a avaliar segurança contratual e previsibilidade de entrega do benefício econômico esperado.",
    whenToReview: [
      "Antes de assinar contrato de adesão.",
      "Na análise jurídica de riscos e responsabilidades.",
      "Ao comparar provedores de energia por assinatura.",
    ],
  },
  {
    term: "Energia por Assinatura",
    slug: "energia-por-assinatura",
    category: "Mercado e Contratos",
    description:
      "Descubra como funciona energia por assinatura para empresas e qual o potencial de economia.",
    definition:
      "Energia por assinatura é o modelo em que a empresa adere a uma solução de compensação energética sem instalar usina própria. O consumidor recebe créditos ou benefícios aplicados à fatura conforme regras do contrato e da distribuidora.",
    impact:
      "É uma opção com baixa barreira de entrada para reduzir custo mensal e acelerar decisão de adesão.",
    whenToReview: [
      "Quando a prioridade é economizar sem investimento inicial.",
      "Quando o time operacional quer evitar gestão de obra e manutenção.",
      "Quando há meta de resultado com execução rápida.",
    ],
  },
  {
    term: "Compensação de Energia Elétrica",
    slug: "compensacao-de-energia-eletrica",
    category: "Regulação e Operação",
    description:
      "Entenda a compensação de energia e como ela aparece na conta da sua empresa.",
    definition:
      "Compensação de energia é o mecanismo regulatório que converte energia gerada em créditos ou abatimentos aplicáveis ao consumo. Na fatura, isso aparece como redução de componentes energéticos conforme as regras técnicas e comerciais aplicáveis.",
    impact:
      "Compreender essa mecânica evita expectativas desalinhadas e melhora a leitura de economia real na conta.",
    whenToReview: [
      "Ao validar a primeira fatura após adesão.",
      "Ao comparar economia prometida versus economia realizada.",
      "Quando ocorrer mudança relevante no perfil de consumo.",
    ],
  },
  {
    term: "Crédito de Energia",
    slug: "credito-de-energia",
    category: "Tarifas e Fatura",
    description:
      "Saiba o que é crédito de energia e como ele reduz despesas na fatura empresarial.",
    definition:
      "Crédito de energia é a unidade de compensação gerada por energia injetada e utilizada para abater consumo em contas elegíveis. Ele não representa dinheiro em caixa, mas sim redução de cobrança em itens energéticos da fatura.",
    impact:
      "Empresas que monitoram créditos com disciplina conseguem prever economia mensal com maior precisão.",
    whenToReview: [
      "No fechamento financeiro mensal da unidade consumidora.",
      "Quando houver variação anormal de consumo.",
      "Ao revisar performance de contrato de energia por assinatura.",
    ],
  },
  {
    term: "Unidade Consumidora (UC)",
    slug: "unidade-consumidora-uc",
    category: "Regulação e Operação",
    description:
      "Entenda o papel da Unidade Consumidora no cadastro e na compensação de energia.",
    definition:
      "Unidade Consumidora é o ponto formal de consumo identificado pela distribuidora, normalmente vinculado ao número da instalação na fatura. É nessa unidade que regras tarifárias, consumo e créditos são processados.",
    impact:
      "Dados corretos da UC são essenciais para evitar atrasos de adesão e inconsistências na aplicação de créditos.",
    whenToReview: [
      "Durante o cadastro inicial de adesão.",
      "Ao incluir novas filiais no contrato.",
      "Sempre que houver troca de titularidade ou alteração cadastral.",
    ],
  },
  {
    term: "Demanda Contratada",
    slug: "demanda-contratada",
    category: "Tarifas e Fatura",
    description:
      "Saiba como a demanda contratada influencia custos fixos e eficiência energética.",
    definition:
      "Demanda contratada é a potência reservada junto à distribuidora para atendimento da unidade, comum em consumidores do Grupo A. Quando mal dimensionada, pode gerar custo desnecessário ou penalidades por ultrapassagem.",
    impact:
      "Ajustar demanda contratada é uma alavanca importante de eficiência de custo para empresas com perfil de carga estável.",
    whenToReview: [
      "Quando há expansão ou redução de equipamentos elétricos.",
      "Após mudanças de turnos operacionais.",
      "Na revisão anual de contratos e despesas fixas.",
    ],
  },
  {
    term: "Horário de Ponta e Fora de Ponta",
    slug: "horario-de-ponta-e-fora-de-ponta",
    category: "Tarifas e Fatura",
    description:
      "Entenda ponta e fora de ponta e como o horário de consumo impacta sua conta.",
    definition:
      "Horário de ponta é a faixa de maior carregamento do sistema elétrico, com tarifas geralmente mais altas. Fora de ponta é o período de menor pressão na rede, normalmente com custo menor por energia consumida.",
    impact:
      "Conhecer esses horários permite ajustar operação para reduzir custo médio do kWh.",
    whenToReview: [
      "Quando o custo por kWh está acima da meta.",
      "Ao planejar produção e operação de equipamentos intensivos em energia.",
      "Na análise de viabilidade de automações de consumo.",
    ],
  },
  {
    term: "Grupo A e Grupo B",
    slug: "grupo-a-e-grupo-b",
    category: "Tarifas e Fatura",
    description:
      "Veja a diferença entre Grupo A e Grupo B e o impacto no modelo tarifário da empresa.",
    definition:
      "Grupo A reúne consumidores atendidos em média ou alta tensão, com estrutura tarifária que inclui demanda contratada. Grupo B reúne consumidores em baixa tensão, com cobrança focada no consumo de energia.",
    impact:
      "Essa classificação define como a conta é formada e quais estratégias de economia são mais eficazes para cada empresa.",
    whenToReview: [
      "Na leitura inicial da fatura para diagnóstico de custos.",
      "Ao abrir nova unidade operacional.",
      "Na comparação de propostas de redução de energia.",
    ],
  },
  {
    term: "Tarifa de Energia (TE)",
    slug: "tarifa-de-energia-te",
    category: "Tarifas e Fatura",
    description:
      "Entenda o que compõe a TE e por que ela é central na economia da conta de luz.",
    definition:
      "A Tarifa de Energia (TE) representa o custo da energia efetivamente consumida. Ela é um dos componentes principais da fatura e costuma ser o foco de modelos de compensação e otimização de contratos.",
    impact:
      "Quanto melhor a estratégia sobre TE, maior tende a ser o ganho econômico recorrente para o CNPJ.",
    whenToReview: [
      "Ao comparar fatura atual com cenário projetado.",
      "Na análise de propostas comerciais de energia.",
      "Em auditorias periódicas de contas de luz.",
    ],
  },
  {
    term: "Tarifa de Uso do Sistema de Distribuição (TUSD)",
    slug: "tarifa-de-uso-do-sistema-de-distribuicao-tusd",
    category: "Tarifas e Fatura",
    description:
      "Saiba o que é TUSD e como esse componente afeta o valor total da conta.",
    definition:
      "TUSD é a tarifa relacionada ao uso da infraestrutura da distribuidora para transportar energia até a unidade consumidora. Ela compõe parte relevante da fatura e varia conforme modalidade tarifária, nível de tensão e regras locais.",
    impact:
      "Entender TUSD ajuda a interpretar corretamente ganhos de economia e expectativas contratuais.",
    whenToReview: [
      "Ao validar variações de valor sem mudança expressiva de consumo.",
      "Quando houver revisão tarifária da distribuidora.",
      "Na negociação de contratos com metas de economia líquida.",
    ],
  },
  {
    term: "Bandeiras Tarifárias",
    slug: "bandeiras-tarifarias",
    category: "Tarifas e Fatura",
    description:
      "Entenda bandeiras tarifárias e por que elas aumentam a volatilidade da conta.",
    definition:
      "Bandeiras tarifárias sinalizam condições de geração no sistema elétrico e podem adicionar cobranças extras à fatura. Elas variam por períodos e refletem custos adicionais de operação do setor.",
    impact:
      "Empresas expostas a bandeiras precisam de estratégia para reduzir imprevisibilidade e preservar margem operacional.",
    whenToReview: [
      "No planejamento de caixa para meses de maior custo de energia.",
      "Na revisão de variações de custo não previstas no orçamento.",
      "Ao avaliar soluções com maior previsibilidade de conta.",
    ],
  },
  {
    term: "Custo do kWh para Empresas",
    slug: "custo-do-kwh-para-empresas",
    category: "Tarifas e Fatura",
    description:
      "Aprenda a calcular o custo real do kWh e identificar oportunidades de economia.",
    definition:
      "Custo do kWh para empresas é o valor médio pago por energia considerando estrutura tarifária, impostos, encargos e perfil de consumo. Ele não se resume a um único item da conta e deve ser analisado com visão completa da fatura.",
    impact:
      "Esse indicador é essencial para comparar unidades, medir eficiência e acompanhar resultado das ações de redução de custos.",
    whenToReview: [
      "No fechamento mensal por unidade de negócio.",
      "Antes e depois de aderir a uma solução energética.",
      "Em decisões de expansão com impacto de utilidades.",
    ],
  },
  {
    term: "Fatura de Energia para CNPJ",
    slug: "fatura-de-energia-para-cnpj",
    category: "Tarifas e Fatura",
    description:
      "Guia rápido para ler a fatura de energia de empresas e achar pontos de otimização.",
    definition:
      "A fatura de energia para CNPJ consolida consumo, tarifas, tributos e encargos aplicados à unidade consumidora. Uma leitura estruturada da fatura permite identificar desperdícios, inconsistências e oportunidades de redução de custo recorrente.",
    impact:
      "Empresas que tratam a fatura como dado estratégico tomam decisões mais rápidas e com melhor retorno financeiro.",
    whenToReview: [
      "Todo mês, com análise padronizada dos principais componentes.",
      "Sempre que houver pico de custo sem causa clara.",
      "Antes de contratar novas soluções de energia.",
    ],
  },
  {
    term: "Lei 14.300/2022 (Marco Legal da GD)",
    slug: "lei-14300-2022-marco-legal-da-gd",
    category: "Regulação e Operação",
    description:
      "Entenda os pontos centrais da Lei 14.300 e seus efeitos na compensação de energia.",
    definition:
      "A Lei 14.300/2022 estabelece diretrizes do marco legal da geração distribuída no Brasil, definindo transição regulatória e parâmetros de compensação. Ela influencia regras econômicas, previsibilidade contratual e planejamento de adesão para consumidores.",
    impact:
      "Conhecer a lei evita decisões baseadas em premissas desatualizadas e melhora a análise de viabilidade.",
    whenToReview: [
      "Ao avaliar contratos de médio e longo prazo.",
      "Quando houver dúvidas sobre regras de compensação aplicáveis.",
      "Ao comparar propostas de diferentes fornecedores.",
    ],
  },
  {
    term: "ANEEL e Regras de Geração Distribuída",
    slug: "aneel-e-regras-de-geracao-distribuida",
    category: "Regulação e Operação",
    description:
      "Saiba como as regras da ANEEL impactam contratos e economia em geração distribuída.",
    definition:
      "A ANEEL é o órgão regulador que define e atualiza regras do setor elétrico, incluindo aspectos técnicos e comerciais da GD. As normas influenciam prazos, elegibilidade, formas de compensação e governança da operação.",
    impact:
      "Aderir com base em regras claras reduz risco de frustração e melhora previsibilidade de resultado.",
    whenToReview: [
      "Antes da assinatura contratual.",
      "Quando houver atualização regulatória relevante.",
      "Na revisão de desempenho e compliance da operação.",
    ],
  },
  {
    term: "Homologação na Distribuidora",
    slug: "homologacao-na-distribuidora",
    category: "Regulação e Operação",
    description:
      "Entenda o que é homologação e por que ela é etapa crítica para ativar economia.",
    definition:
      "Homologação é a etapa em que a distribuidora valida tecnicamente a habilitação para compensação de energia na unidade consumidora. O processo envolve documentos, validações cadastrais e critérios operacionais.",
    impact:
      "Sem homologação concluída, a economia não entra na fatura; por isso, gestão de prazo é decisiva para conversão de valor.",
    whenToReview: [
      "Logo após a contratação.",
      "Em casos de atraso de ativação.",
      "Quando houver pendência documental da unidade consumidora.",
    ],
  },
  {
    term: "Medidor Bidirecional",
    slug: "medidor-bidirecional",
    category: "Regulação e Operação",
    description:
      "Saiba o papel do medidor bidirecional na medição e compensação de energia.",
    definition:
      "O medidor bidirecional registra energia consumida e energia injetada/compensada, conforme o arranjo regulatório aplicável. Ele é parte importante da infraestrutura de medição para viabilizar cálculo correto de créditos.",
    impact:
      "Medição correta é requisito para que a economia prevista se materialize de forma confiável na fatura.",
    whenToReview: [
      "Quando iniciar a fase de ativação com a distribuidora.",
      "Ao investigar divergência entre consumo e crédito.",
      "Na auditoria periódica de contas e medições.",
    ],
  },
  {
    term: "Prazo de Ativação do Contrato de Energia por Assinatura",
    slug: "prazo-de-ativacao-do-contrato-de-energia-por-assinatura",
    category: "Mercado e Contratos",
    description:
      "Entenda o prazo de ativação e como planejar expectativa de economia desde o onboarding.",
    definition:
      "Prazo de ativação é o intervalo entre assinatura do contrato e início efetivo da compensação na fatura. Esse tempo depende de validações cadastrais, processos da distribuidora e execução operacional do provedor.",
    impact:
      "Definir prazo realista melhora gestão de expectativa com o financeiro e acelera confiança no processo.",
    whenToReview: [
      "No momento da contratação.",
      "No acompanhamento semanal de implantação.",
      "Se a economia não aparecer no período estimado.",
    ],
  },
  {
    term: "Desconto na Conta de Luz para Empresas",
    slug: "desconto-na-conta-de-luz-para-empresas",
    category: "Tarifas e Fatura",
    description:
      "Veja de onde vem o desconto na conta de luz empresarial e como medir resultado real.",
    definition:
      "Desconto na conta de luz para empresas é a redução obtida por meio de estratégia de contratação, compensação ou otimização tarifária. O resultado real deve ser medido sobre a fatura líquida, considerando regras aplicáveis e perfil de consumo.",
    impact:
      "Medir desconto corretamente evita erro de decisão e orienta melhor a expansão para outras unidades.",
    whenToReview: [
      "No comparativo mês a mês da fatura.",
      "Ao validar ROI de iniciativas energéticas.",
      "Antes de escalar solução para toda a empresa.",
    ],
  },
  {
    term: "Economia de Energia sem Investimento Inicial",
    slug: "economia-de-energia-sem-investimento-inicial",
    category: "Mercado e Contratos",
    description:
      "Entenda como reduzir custo de energia sem CAPEX e quais cuidados avaliar no contrato.",
    definition:
      "Economia sem investimento inicial é o modelo em que a empresa reduz custo energético por adesão contratual, sem comprar ou instalar usina própria. O ganho vem de estrutura de fornecimento e compensação operada por parceiro especializado.",
    impact:
      "Esse modelo costuma acelerar decisão de compra porque preserva caixa e reduz barreiras de implantação.",
    whenToReview: [
      "Quando CAPEX está comprometido com outras prioridades.",
      "Quando há urgência em reduzir custo fixo.",
      "Ao comparar alternativas de energia com diferentes riscos de execução.",
    ],
  },
  {
    term: "Carência Contratual de Energia por Assinatura",
    slug: "carencia-contratual-de-energia-por-assinatura",
    category: "Mercado e Contratos",
    description:
      "Saiba o que é carência contratual e como isso afeta flexibilidade da empresa.",
    definition:
      "Carência contratual é o período mínimo previsto no contrato antes de determinadas alterações ou encerramentos sem penalidade. Ela ajuda a dar estabilidade operacional ao modelo e precisa ser analisada junto à expectativa de consumo da empresa.",
    impact:
      "Entender carência evita surpresas de flexibilidade e melhora alinhamento jurídico-financeiro na contratação.",
    whenToReview: [
      "Durante a negociação e revisão contratual.",
      "Ao planejar mudanças de unidade ou encerramento de operação.",
      "Na decisão de expansão para outras filiais.",
    ],
  },
  {
    term: "Multa de Rescisão em Contrato de Energia",
    slug: "multa-de-rescisao-em-contrato-de-energia",
    category: "Mercado e Contratos",
    description:
      "Entenda quando existe multa de rescisão e como reduzir risco contratual na adesão.",
    definition:
      "Multa de rescisão é a penalidade prevista para encerramento antecipado do contrato, conforme cláusulas comerciais acordadas. Ela deve ser avaliada junto ao prazo, ao potencial de economia e ao risco de variação do perfil de consumo.",
    impact:
      "Uma análise prévia dessa cláusula evita custo inesperado e protege a decisão de adesão.",
    whenToReview: [
      "Na etapa jurídica de aprovação contratual.",
      "Quando houver chance de fechamento, mudança ou venda da unidade.",
      "Ao renegociar condições com o fornecedor.",
    ],
  },
  {
    term: "ICMS na Conta de Luz",
    slug: "icms-na-conta-de-luz",
    category: "Tributação",
    description:
      "Saiba como o ICMS impacta a conta de energia e por que isso importa no cálculo de economia.",
    definition:
      "ICMS é um imposto estadual que incide sobre componentes da fatura de energia conforme regras aplicáveis. A forma de incidência afeta o valor final pago e precisa ser considerada em qualquer projeção de economia.",
    impact:
      "Ignorar ICMS na análise pode inflar expectativa de desconto e distorcer o resultado financeiro real.",
    whenToReview: [
      "Na comparação entre valor bruto e valor líquido da fatura.",
      "Ao avaliar propostas de redução de energia.",
      "Em revisões tributárias com contabilidade e fiscal.",
    ],
  },
  {
    term: "PIS/COFINS na Conta de Energia",
    slug: "pis-cofins-na-conta-de-energia",
    category: "Tributação",
    description:
      "Entenda como PIS e COFINS aparecem na conta e como entram no cálculo de custo energético.",
    definition:
      "PIS e COFINS são contribuições federais presentes na composição da fatura de energia elétrica. Elas impactam o custo total e devem ser observadas no cálculo de economia efetiva e no acompanhamento de performance financeira.",
    impact:
      "Considerar esses tributos melhora a acurácia da análise e evita decisões com base em economia superestimada.",
    whenToReview: [
      "No fechamento mensal de despesas energéticas.",
      "Na validação de propostas comerciais.",
      "Em auditorias de custo por unidade de negócio.",
    ],
  },
];

const sortedGlossaryTerms = [...glossaryTerms].sort((a, b) =>
  a.term.localeCompare(b.term, "pt-BR"),
);

const glossaryTermsBySlug = sortedGlossaryTerms.reduce((acc, term) => {
  acc[term.slug] = Object.assign({}, term, {
    path: `/glossario/${term.slug}`,
  });
  return acc;
}, {});

export const glossaryCategories = Array.from(
  new Set(sortedGlossaryTerms.map((term) => term.category)),
).sort((a, b) => a.localeCompare(b, "pt-BR"));

export const getGlossaryTerms = () => sortedGlossaryTerms;

export const getGlossaryTermBySlug = (slug) => glossaryTermsBySlug[slug] || null;

export const getGlossaryTermsByCategory = (category) =>
  sortedGlossaryTerms.filter((term) => term.category === category);

export const getRelatedGlossaryTerms = (slug, limit = 4) => {
  const current = getGlossaryTermBySlug(slug);
  if (!current) return [];

  const sameCategory = getGlossaryTermsByCategory(current.category).filter(
    (term) => term.slug !== slug,
  );
  const fallback = sortedGlossaryTerms.filter(
    (term) => term.slug !== slug && term.category !== current.category,
  );

  return [...sameCategory, ...fallback].slice(0, limit);
};

export { sortedGlossaryTerms as glossaryTerms };
